import { Heart, MoreVertical } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { ContactFormSheet } from "@/components/ContactFormSheet";
import { AboutSheet } from "@/components/AboutSheet";
import { SocialShare } from "@/components/SocialShare";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { useIsMobile } from "@/hooks/use-mobile";

export const FooterLinks = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Sheet>
        <SheetTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="fixed top-4 right-4 z-50 glass-card hover:scale-105 smooth-transition"
          >
            <MoreVertical className="h-5 w-5" />
          </Button>
        </SheetTrigger>
        <SheetContent side="bottom" className="glass-card border-t border-border/50">
          <SheetHeader>
            <SheetTitle>Menu</SheetTitle>
          </SheetHeader>
          <div className="flex flex-col gap-3 mt-4">
            <AboutSheet />
            <SocialShare />
            <Button
              variant="secondary"
              size="sm"
              className="glass-card group w-full hover:scale-105 smooth-transition"
              onClick={() => window.open("https://buymeacoffee.com/skylofiatc", "_blank")}
            >
              <Heart className="h-4 w-4 mr-2 group-hover:text-red-500 transition-colors" />
              Donate
            </Button>
            <ContactFormSheet />
          </div>
        </SheetContent>
      </Sheet>
    );
  }

  return (
    <TooltipProvider delayDuration={200}>
      <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-2">
        <AboutSheet className="text-foreground" />
        <SocialShare className="text-foreground" />
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="secondary"
              size="sm"
              className="glass-card hover:scale-105 smooth-transition group text-foreground"
              onClick={() => window.open("https://buymeacoffee.com/skylofiatc", "_blank")}
            >
              <Heart className="h-4 w-4 mr-2 group-hover:text-red-500 transition-colors" />
              Donate
            </Button>
          </TooltipTrigger>
          <TooltipContent className="max-w-[200px]">
            Like the vibe? Help keep this site running with a small donation. Server costs for streaming aren't cheap,
            and your support keeps it free and ad-free for everyone. ✈️
          </TooltipContent>
        </Tooltip>
        <ContactFormSheet className="text-foreground" />
      </div>
    </TooltipProvider>
  );
};
